import { memo } from 'react';
import type { LogLevel } from '@/types';

interface TerminalLogProps {
  level: LogLevel;
  text: string;
  displayedText: string;
}

const logLevelColors: Record<LogLevel, string> = {
  SYSTEM: '#BBB529',
  INFO: '#6A8759',
  WARN: '#CC7832',
  ERROR: '#FF6B68',
  DEBUG: '#9876AA',
};

export const TerminalLog = memo(function TerminalLog({ level, text, displayedText }: TerminalLogProps) {
  const color = logLevelColors[level];
  const isComplete = displayedText.length === text.length;

  return (
    <div className="flex items-start gap-2 font-terminal text-sm">
      <span style={{ color }} className="font-bold">
        [{level}]
      </span>
      <span className="text-[#A9B7C6]">
        {displayedText}
        {!isComplete && <span className="cursor-blink text-[#FFFFFF] ml-1">▊</span>}
      </span>
    </div>
  );
});
